import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import OrderTracking from "./pages/OrderTracking";
import { Toaster } from "sonner";

const App = () => {
  return (
    <Router>
      <Toaster position="top-right" richColors closeButton />

      <Routes>
        <Route path="/:trackingId" element={<OrderTracking />} />
        <Route path="/:trackingId/admin" element={<OrderTracking />} />
        <Route path="/" element={<div />} />
      </Routes>
    </Router>
  );
};

export default App;
